export const id = '402103412424179713'

export const github = 'https://github.com/creat1vv'

export const telegram = 'https://t.me/creat1vv'

export const theme = 'dark'